/**
 * Constantes de Contratos e Status Compartilhadas
 */

export const LINK_DOCUSIGN_FALLBACK =
  "https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=72bb8440-acc9-4e15-b87e-f80823d9d92f&env=na2&acct=272fb0e3-8eca-4797-ac82-b4ba543c625f&v=2";

export const LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK =
  "https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=332d1eb3-e52c-497a-bcf9-da18ae0d0234&env=na2&acct=272fb0e3-8eca-4797-ac82-b4ba543c625f&v=2";

export const STATUS_LABELS = {
  PENDENTE: "Pendente",
  AGUARDANDO_ESTUDANTE: "Aguardando preenchimento do Estudante",
  AGUARDANDO_VALIDACAO_CIEEMG: "Aguardando validação do CIEEMG",
  EM_VALIDACAO: "Em validação pelo CIEEMG",
  AGUARDANDO_CONFECCAO: "Aguardando confecção do contrato",
  CONTRATO_CONFECCIONADO: "Contrato confeccionado",
  AGUARDANDO_ASSINATURAS: "Aguardando assinaturas",
  DISPONIBILIZADO_PARA_ASSINATURA: "Disponibilizado para assinatura",
  FINALIZADO: "Finalizado",
  APROVADO: "Aprovado",
  REPROVADO_EMPRESA: "Reprovado — voltar p/ Empresa",
  REPROVADO_ESTUDANTE: "Reprovado — voltar p/ Estudante",
  REPROVADO_DEFINITIVO: "Reprovado definitivamente",
  RECUSADO: "Recusado",
};

export const STATUS_CORES = {
  PENDENTE: "#3b82f6",
  AGUARDANDO_ESTUDANTE: "#3b82f6",
  AGUARDANDO_VALIDACAO_CIEEMG: "#3b82f6",
  EM_VALIDACAO: "#1e40af",
  AGUARDANDO_CONFECCAO: "#3b82f6",
  CONTRATO_CONFECCIONADO: "#1e40af",
  AGUARDANDO_ASSINATURAS: "#3b82f6",
  DISPONIBILIZADO_PARA_ASSINATURA: "#1e40af",
  FINALIZADO: "#1e3a8a",
  APROVADO: "#1e3a8a",
  REPROVADO_EMPRESA: "#ef4444",
  REPROVADO_ESTUDANTE: "#ef4444",
  REPROVADO_DEFINITIVO: "#dc2626",
  RECUSADO: "#dc2626",
};

export const ANEXO_ID_SUFFIXES_TO_STRIP = ["_path", "_nome"];
